module.exports = __webpack_public_path__ + "img/file-zip.3841a9ec.svg";